import styled from "styled-components";
import { keyframes } from "styled-components";
const StyledFormCheckBox = styled.div`
    display: flex;
    padding-top: 15px;
    align-items: center;
    cursor: pointer;
    user-select: none;
`;

const LabelRegular = styled.div`
    font-size: 12px;
    font-weight: 600;

    ${({ disabled }) => disabled === true && `
        color: #E9E9E9;
    `}
`;

const Input = styled.input`
  height: 0;
  width: 0;
  opacity: 0;
  z-index: -1;
`;

const Label = styled.label`
    margin-left: 10px;
    position: relative;
    display: inline-block;
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
`;

const rotate = keyframes`
    from {
        opacity: 0;
        transform: rotate(0deg);
    }
    to {
        opacity: 1;
        transform: rotate(45deg);
    }
`;

const Indicator = styled.div`
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    position: absolute;
    top: 1px;
    left: 0;
    border: solid 2px ${(props) => props.theme.color.dark};
    border-radius: 5px;

    ${Input}:not(:disabled):checked & {
        background: #d1d1d1;
    }

    &::after {
        content: "";
        position: absolute;
        display: none;
    }

    ${Input}:checked + &::after {
        display: block;
        top: 3px;
        left: 6px;
        width: 17%;
        height: 40%;
        border: solid ${(props) => props.theme.color.dark};
        border-width: 0 2px 2px 0;
        animation-name: ${rotate};
        animation-fill-mode: forwards;
    }

    ${Input}:disabled:checked + &::after {
        display: block;
        top: 3px;
        left: 6px;
        width: 17%;
        height: 40%;
        border: solid ${(props) => props.theme.color.disabledgray};
        border-width: 0 2px 2px 0;
        animation-name: ${rotate};
        animation-fill-mode: forwards;
    }

    &::disabled {
        cursor: not-allowed;
    }

    ${({ disabled }) => disabled === true && `
        border-color: #C1C1C1;
    `}
`;


function FormCheckBox(props) {

    const {label, checked, disabled, onCheck, ...restProps} = props;

    return (
        <StyledFormCheckBox {...restProps}>
            <LabelRegular disabled={disabled} onClick={() => {if (!disabled) onCheck(!checked)}}>{label}</LabelRegular>
            <Label disabled={disabled}>
            <Input
                type="checkbox"
                disabled={disabled}
                checked={checked}
                onChange={() => {onCheck(!checked)}}
            />
            <Indicator disabled={disabled}/>
            </Label>
        </StyledFormCheckBox>
    )
}

export default FormCheckBox;